import { gql } from '@apollo/client'
import { USER_FRAGMENT } from '../fragments'

export const GET_COMPANY_USERS = gql`
  query GetCompanyUsers($input: CompanyUsersInput!) {
    companyUsers(input: $input) {
      results {
        ...User
      }
      hasMore
      count
    }
  }
  ${USER_FRAGMENT}
`
